// src/components/Header/Sidenav.jsx (or wherever your SideNav/ModernDrawer is located)

import React from 'react';
import { Box, Drawer, IconButton, Typography, Link, Button } from '@mui/material';
import COLORS from '../../constants/colors'; // Import colors
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram, faTwitter, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import logo from "../../assets/logo.png"; // Import your logo
import { PrimaryButton, OutlinedButton } from '../Reusable/Button'; // <--- ADD THIS IMPORT


const ModernDrawer = ({ mode, drawerOpen, toggleDrawer }) => {
  // Menu Items Array (moved inside the component for direct access, or can be imported)
  const menuItems = [
    { label: 'Home', link: '/' },
    { label: 'Campaigns', link: '/campaigns' },
    { label: 'Register Organization', link: '/org/register' },
    { label: 'How it works', link: '/how-it-works' },
    { label: 'Impact', link: '/impact' },
    { label: 'Contact us', link: '/contactus' },
  ];

  // Social Media Links Array (moved inside the component, or can be imported)
  const socialLinks = [
    { icon: faLinkedin, link: 'https://www.linkedin.com/company/yamba-africa' },
    { icon: faTwitter, link: 'https://x.com/yamba_africa' },
    { icon: faInstagram, link: 'https://www.instagram.com/yamba_africa/' },
  ];

  return (
    <Drawer
      anchor="left"
      open={drawerOpen}
      onClose={toggleDrawer}
      PaperProps={{
        sx: {
          boxShadow: 'none',
          margin: '16px',
          height: 'auto',
          maxHeight: '95vh',
          borderRadius: '10px',
          overflowY: 'auto',
          backgroundColor: COLORS.white,
          backdropFilter: 'blur(50px)',
        },
      }}
    >
      <Box
        sx={{
          width: 300,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start',
          padding: '14px',
          overflow: 'hidden',
          backgroundColor: 'transparent',
        }}
      >
        {/* Header: Close Button & Logo */}
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            px: 1,
            mt: 1,
          }}
        >
          
          <IconButton
            onClick={toggleDrawer}
            sx={{
              backgroundColor: COLORS.primary,
              p: '15px',
              height: '40px',
              width: '40px',
              '&:hover': { backgroundColor: COLORS.primary },
            }}
          >
            <FontAwesomeIcon icon={faTimes} style={{ color: COLORS.white, fontSize: '16px' }} />
          </IconButton>
        </Box>

        {/* Menu Items */}
        <Box sx={{ width: '85%', mb: 3 }}>
          {menuItems.map((item) => (
            <Link
              key={item.label}
              href={item.link}
              underline="none"
              sx={{
                display: 'block',
                color: COLORS.primary,
                fontSize: '14px',
                padding: '12px 20px',
                borderRadius: '8px',
                width: '100%',
                textAlign: 'center',
                marginBottom: '6px',
                cursor: 'pointer',
                transition: 'background-color 0.3s, transform 0.2s, color 0.3s',
                '&:hover': {
                  backgroundColor: mode === 'light' ? COLORS.lightGray : COLORS.primary,
                  color: mode === 'light' ? COLORS.primary : COLORS.white,
                  transform: 'scale(1.05)',
                },
              }}
            >
              {item.label}
            </Link>
          ))}
        </Box>

        {/* Login & Register Buttons - NOW IN SIDENAV */}
        <Box
          sx={{
            width: '85%',
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            mb: 4,
          }}
        >
       {/* Register Button (using OutlinedButton) */}
                <OutlinedButton // <--- REPLACED Button with OutlinedButton
                  component="a"
                  href="/user/register"
                 
                >
                  Register
                </OutlinedButton>
      
                {/* Login Button (using PrimaryButton) */}
                <PrimaryButton // <--- REPLACED Button with PrimaryButton
                  component="a"
                  href="/user/login"
                  
                >
                  Login
                </PrimaryButton>
        </Box>

        {/* Social Media Links */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 'bold', mb: '10px' }}>
            Follow Us
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'center', gap: '15px' }}>
            {socialLinks.map(({ icon, link }) => (
              <a key={link} href={link} target="_blank" rel="noopener noreferrer">
                <FontAwesomeIcon
                  icon={icon}
                  style={{
                    color: COLORS.primary,
                    fontSize: '18px',
                    cursor: 'pointer',
                    transition: 'color 0.3s, transform 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = COLORS.secondary;
                    e.currentTarget.style.transform = 'scale(1.2)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = COLORS.primary;
                    e.currentTarget.style.transform = 'scale(1)';
                  }}
                />
              </a>
            ))}
          </Box>
        </Box>

        {/* Contact Information */}
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Typography sx={{ fontSize: '14px', color: COLORS.primary, fontWeight: 'bold', mb: '8px' }}>
            Email us
          </Typography>
          <Typography sx={{ fontSize: '12px', color: COLORS.primary }}>support@yambaafrica.com</Typography>
        </Box>
      </Box>
    </Drawer>
  );
};

export default ModernDrawer;